import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import { formatMetric } from '../../../../utils/money';
import { Card, DeltaBadge, DetailRow, Skeleton } from '../../../ui';

const muted = 'text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor';

const rowLabel = (label, channel) => {
  const trimmed = label.toLowerCase().startsWith(`${channel.toLowerCase()} `) ? label.slice(channel.length + 1) : label;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};

const MetricRow = ({ metric, channel }) => {
  const missing = metric.value === null || metric.value === undefined;

  return (
    <DetailRow
      label={rowLabel(metric.label, channel)}
      value={
        <span className="inline-flex items-center gap-2">
          {formatMetric(metric)}
          {!missing && (
            <DeltaBadge
              deltaPct={metric.delta_pct}
              direction={metric.direction}
              isImprovement={metric.is_improvement}
            />
          )}
        </span>
      }
    />
  );
};

const Channel = ({ title, ChannelIcon, accent, metrics, loading }) => (
  <Card
    className="col-span-12 mb-0 h-full xl:col-span-6"
    title={
      <span className="inline-flex items-center gap-3">
        <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded ${accent}`}>
          <ChannelIcon className="w-4 h-4" aria-hidden="true" />
        </span>
        {title}
      </span>
    }
  >
    {loading
      ? Array.from({ length: 5 }, (_, index) => (
          <DetailRow key={index} label={<Skeleton w="8rem" h="0.9rem" />} loading />
        ))
      : metrics.map((metric) => <MetricRow key={metric.key} metric={metric} channel={title} />)}
  </Card>
);

const IssuingAcquiringPanel = ({ issuing = [], acquiring = [], loading }) => (
  <div>
    <div className="mb-4 flex flex-wrap items-baseline gap-x-3 gap-y-1">
      <h5 className="mb-0">Channels</h5>
      <span className={`text-sm ${muted}`}>
        Issuing and acquiring are disjoint halves of the totals above; together they make up every transaction.
      </span>
    </div>
    <div className="grid grid-cols-12 gap-6">
      <Channel
        title="Issuing"
        ChannelIcon={ArrowUpRight}
        accent="bg-primary-500/10 text-primary-500"
        metrics={issuing}
        loading={loading}
      />
      <Channel
        title="Acquiring"
        ChannelIcon={ArrowDownLeft}
        accent="bg-info-500/10 text-info-500"
        metrics={acquiring}
        loading={loading}
      />
    </div>
  </div>
);

export default IssuingAcquiringPanel;
